const LEGACY_SCRIPTS = [
  'https://unpkg.com/scrollreveal/dist/scrollreveal.min.js',
  '/assets/js/main.js',
  '/assets/js/color-picker.js',
  '/assets/js/color-flow.js',
  '/assets/js/stars.js',
  '/assets/js/save-contact.js',
  '/assets/js/shooting-stars.js',
  '/assets/js/scratch-card.js',
  '/assets/js/profile-flip.js',
  '/assets/js/chatbot.js',
  '/assets/js/jarvis-orb.js',
  '/assets/js/projects-filter.js',
  '/assets/js/premium-effects.js',
  '/assets/js/ticker-portrait.js',
  '/assets/js/easter-eggs.js',
  '/assets/js/spotify-icon.js',
  '/assets/js/quote-of-the-day.js',
  '/assets/js/github-contributions.js',
  'https://cdn.jsdelivr.net/npm/particles.js@2.0.0/particles.min.js',
  '/assets/js/ultra-premium.js',
];

function loadScript(src) {
  return new Promise((resolve, reject) => {
    const el = document.createElement('script');
    el.src = src;
    el.async = false;
    el.onload = () => resolve();
    el.onerror = () => reject(new Error(`Failed to load script: ${src}`));
    document.body.appendChild(el);
  });
}

export async function loadLegacyScripts() {
  for (const src of LEGACY_SCRIPTS) {
    await loadScript(src);
  }
}
